import React, { Component } from 'react';
import { Row, Spin, DatePicker, Button, message } from "antd";
import { setYCategory } from "@/method/analysis";
import moment from "moment";
import { calculation } from '../../../../method';
import { imgToPdf } from "imgtopdf";
import jsPDF from 'jspdf';

const { MonthPicker } = DatePicker;

class App extends Component {
    state = {
        date: moment().subtract(1, 'month').format('YYYY-MM'),
        data: [],
        loading: true,
        loadingSave: false,
        print: false,
        dataSelect: []
    }

    componentDidMount() {
        this.getDateData(this.state.date);
        window.addEventListener('resize', () => {
            if (window.location.hash === '#/table/otashow') {
                setYCategory({ id: "otashow" }, true);
            }
        });
    }

    getDateData = async (date) => {
        const year = moment(date).format('YYYY');
        const month = moment(date).format('M');

        fetch(`/getOtaFillIn?year=${year}&month=${month}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            let maxNum = (x.data.data || []).reduce((a, b) => b.num > a ? b.num : a, 1);
            let data = (x.data.data || []).filter(item => item.num > 0)
                .map(item => {
                    return {
                        name: item.name,
                        num: calculation(item.num, maxNum, 3),
                    }
                }).sort((a, b) => a.num - b.num);
            const otashow = {
                id: "otashow",
                dataX: [{ name: "集团飞猪旗舰店当月客房间夜数销售排名", data: data.map(x => x.num) }],
                dataY: data.map(x => x.name),
                color: ['#4c9bf2'],
                grid: {
                    left: 300
                }
            };
            setYCategory(otashow, false);
            this.setState({ loading: false, data });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        });
    }

    onExportPdf = () => {

        this.setState({ print: true, loading: true }, () => {
            imgToPdf('table4_1_1', 1.5).then(x => {
                let canvas = x.canvas;
                var pageData = canvas.toDataURL('image/png', 1);

                //方向默认横向，尺寸ponits, 按照图片大小进行输出
                var pdf = new jsPDF('l', 'pt', [canvas.width * 0.4, canvas.height]);
                //需要dataUrl格式
                pdf.addImage(pageData, 'PNG', 0, 0, canvas.width, canvas.height);
                pdf.save(`Fliggy Store Rooms Nights Ranking - Current Month 集团飞猪旗舰店当月客房间夜数销售排名 ${this.state.date}.pdf`);
                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                message.error('导出失败请重试！');
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    render() {
        const { loading, print, date } = this.state;
        return (
            <Spin spinning={loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table4_1_1" style={{ width: print ? 4450 : 'auto' }}>
                        <Row>1.1 Fliggy Store Rooms Nights Ranking - Current Month 集团飞猪旗舰店当月客房间夜数销售排名</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str);
                                }}
                            />
                        </Row>

                        <div id="otashow" style={{ height: 650, width: "calc(100% - 48px)", marginTop: 20 }} />
                    </Row>
                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            onClick={this.onExportPdf}
                            loading={this.state.print}
                        >导出PDF</Button>
                    </Row>
                </div>
            </Spin >
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/OTAChannel/show/index.js